import { Component, Input, OnInit } from '@angular/core';


export class SidepanelComponent implements OnInit {

   sidePanelOpen: boolean = true;
   context: 'list' | 'board' = 'list'; // 'list' or 'board'

  backlogSelected: boolean = true;
  typeGroupSelected: boolean = true;

  constructor() {
  }

  ngOnInit() {}
  setGuidedTypeWI() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidePanelOpen': [{ type: Input },],
'context': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
